import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 3C7.02944 3 3 7.02944 3 12C3 15.3297 4.80766 18.2384 7.49994 19.7961L8.36549 20.2969L7.36386 22.028L6.49831 21.5272C3.21354 19.6266 1 16.0724 1 12C1 5.92487 5.92487 1 12 1C13.2027 1 14.3623 1.19339 15.4481 1.55154L16.3977 1.86478L15.7713 3.76412L14.8216 3.45088C13.9354 3.15858 12.9872 3 12 3ZM20.981 4.41444L15.4386 9.95577C15.7949 10.554 16 11.2535 16 12.0001C16 14.2092 14.2091 16.0001 12 16.0001C9.79086 16.0001 8 14.2092 8 12.0001C8 9.79095 9.79086 8.00009 12 8.00009C12.7362 8.00009 13.4266 8.19956 14.0193 8.54668L19.5669 3.00009L20.981 4.41444ZM22.1352 7.60226L22.4485 8.55193C22.8066 9.63775 23 10.7973 23 12C23 16.0713 20.7877 19.6247 17.5044 21.5257L16.639 22.0267L15.6369 20.2959L16.5023 19.7948C19.1933 18.2367 21 15.3288 21 12C21 11.0128 20.8414 10.0646 20.5491 9.17841L20.2359 8.22874L22.1352 7.60226Z"}}]};

const DashboardFilled = Vue.extend<IconProps>({
  name: 'DashboardFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'dashboard-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DashboardFilled;
